/**
 * A very small router. Six routes do not need a dependency.
 */

import { useEffect, useState } from 'react';

export function navigate(path: string, replace = false): void {
  if (replace) window.history.replaceState({}, '', path);
  else window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath(): string {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onChange = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onChange);
    return () => window.removeEventListener('popstate', onChange);
  }, []);

  return path;
}

/**
 * Match `/c/:token` against the current path, returning the params or null.
 */
export function match(
  pattern: string,
  path: string,
): Record<string, string> | null {
  const expected = pattern.split('/').filter(Boolean);
  const actual = path.split('/').filter(Boolean);
  if (expected.length !== actual.length) return null;

  const params: Record<string, string> = {};
  for (let i = 0; i < expected.length; i++) {
    const part = expected[i]!;
    if (part.startsWith(':')) {
      params[part.slice(1)] = decodeURIComponent(actual[i]!);
      continue;
    }
    if (part !== actual[i]) return null;
  }
  return params;
}
